
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#F07300"}}),_c('path',{attrs:{"d":"M13.17 20.65h1.084v1.905H13.17v2.263h-2.468v-2.263H6.58l-.147-1.51 4.27-6.87v-.021h2.468v6.496zm-4.387 0h1.92v-3.28l-.155.248-1.765 3.032zM22.743 20.46c0 1.44-.324 2.551-.974 3.332-.644.782-1.555 1.172-2.732 1.172-1.186 0-2.104-.393-2.754-1.179-.65-.786-.974-1.894-.974-3.325v-1.948c0-1.44.322-2.552.967-3.333.65-.781 1.565-1.172 2.747-1.172 1.181 0 2.097.393 2.746 1.18.65.786.974 1.897.974 3.332v1.941zm-2.468-2.263c0-.767-.1-1.338-.3-1.714-.2-.38-.518-.571-.953-.571-.424 0-.734.175-.93.527-.19.352-.293.884-.307 1.597v2.724c0 .796.1 1.38.3 1.75.2.367.517.55.952.55.42 0 .73-.178.93-.535.2-.36.303-.925.308-1.691v-2.637zM31.466 24.818h-7.441v-1.612l3.428-3.603c.844-.962 1.267-1.726 1.267-2.293 0-.458-.1-.808-.3-1.047-.2-.24-.491-.359-.872-.359-.376 0-.681.161-.916.484-.234.317-.351.715-.351 1.193h-2.476c0-.654.164-1.257.49-1.808a3.432 3.432 0 011.363-1.304A4.046 4.046 0 0127.606 14c1.153 0 2.039.266 2.66.798.624.533.937 1.297.937 2.293 0 .42-.078.83-.235 1.23-.156.396-.4.813-.732 1.253-.327.434-.857 1.018-1.59 1.75l-1.377 1.59h4.197v1.904z","fill":"#fff"}})])
          )
        }
      }
    